export default "__VITE_ASSET__FP71MtQh__"